<template>
    <div class="buefy-header">
        <div class="header bg">
            <!-- Sidebar Collapse -->
            <div class="item-left clickable" @click="$store.dispatch('toogleMenu')">
                <svg class="svg-icons" v-show="showMenu">
                    <use
                        :xlink:href="require('@/assets/img/icons/backburger.svg') + '#layer'"
                    ></use>
                </svg>
                <svg class="svg-icons" v-show="!showMenu">
                    <use
                        :xlink:href="require('@/assets/img/icons/forwardburger.svg') + '#layer'"
                    ></use>
                </svg>
            </div>
            <!-- Logo -->
            <div class="item-left item-logo">
                <img class="logo" :src="logo" alt />
            </div>

            <!-- LGPD -->
            <div class="item-right mt-2 lgpd-content">
                <a
                    v-if="hide.hideInfo && !hide.infoIsHidden"
                    class="lgpd"
                    @click="openModalSobreLgpd"
                >
                    <b-icon
                        icon="information-outline"
                        type="is-danger"
                        size="is-small"
                        class="mr-1"
                    />
                    <span>{{ $t('sobre-a-lgpd') }}</span>
                </a>
                <b-modal v-model="isLgpdModalActive" :width="1024" scroll="keep">
                    <div class="card" color="primary">
                        <header class="card-header">
                            <p class="card-header-title">{{ this.sobre.titulo }}</p>
                        </header>
                        <div class="card-content">
                            <div class="content" v-html="sobre.conteudo"></div>
                        </div>
                    </div>
                </b-modal>
            </div>

            <!-- Language -->
            <div class="item-right lang">
                <b-dropdown aria-role="list">
                    <button class="button" slot="trigger">
                        <svg class="svg-icons">
                            <use
                                :xlink:href="
                                    require(`@/assets/img/langflags/${$i18n.locale}.svg`) + '#layer'
                                "
                            ></use>
                        </svg>
                        <span class="ml-1">{{ $t('lang') }}</span>
                    </button>

                    <b-dropdown-item
                        aria-role="listitem"
                        v-for="(language, i) in ['pt', 'en', 'es']"
                        :key="i"
                        @click="changeLanguage(language)"
                    >
                        <svg class="svg-icons">
                            <use
                                :xlink:href="
                                    require(`@/assets/img/langflags/${language}.svg`) + '#layer'
                                "
                            ></use>
                        </svg>
                        <span class="ml-1" v-text="$t(language)" />
                    </b-dropdown-item>
                </b-dropdown>
            </div>
            <!-- Motificações -->
            <div class="item-right mt-2">
                <div class="notificacao clickable" @click="showNotification = true">
                    <div class="contagem" v-if="notificacaoQtd != 0">
                        <span>{{ notificacaoQtd }}</span>
                    </div>
                    <b-icon icon="bell-ring-outline" type="is-primary" />
                </div>
                <!-- Componente para mostrar notificações -->
                <LateralNotification
                    v-model="showNotification"
                    :reloadData="showNotification"
                    @totalRows="notificacaoQtd = $event"
                />
            </div>
            <!-- User Button -->
            <div class="item-right user clickable">
                <b-dropdown aria-role="list" :position="'is-bottom-left'">
                    <span slot="trigger">
                        <b-icon icon="account-circle" type="is-primary" />
                    </span>

                    <b-dropdown-item aria-role="listitem" class="usuario-logado" disabled>
                        <span>
                            <b-icon
                                icon="circle"
                                size="is-small"
                                class="menu-wrapper"
                                type="is-success"
                            >
                            </b-icon>
                            {{ usuarioLogado }}
                        </span>
                    </b-dropdown-item>

                    <b-dropdown-item
                        v-for="(item, i) in userMenu.admin"
                        :key="i"
                        aria-role="listitem"
                        @click="$router.push({ name: item.codigounicotela })"
                    >
                        <div class="profile-item">
                            <svg class="svg-icons" v-if="!item.iconeexterno">
                                <use
                                    :xlink:href="
                                        require(`@/assets/img/icons/${item.icone}.svg`) + '#layer'
                                    "
                                ></use>
                            </svg>
                            <b-icon
                                v-else-if="item.iconeexterno"
                                class="menu-wrapper"
                                custom-class="menu-icon"
                                :icon="item.icone"
                            />
                            <div :class="tagnew(item.tagnew)">{{ $t(item.nome) }}</div>
                        </div>
                    </b-dropdown-item>

                    <hr class="dropdown-divider" v-if="userMenu.admin && userMenu.admin.size > 0" />

                    <b-dropdown-item aria-role="listitem" @click="confirmLogoutModal()">
                        <a class="profile-item">
                            <svg class="svg-icons">
                                <use
                                    :xlink:href="
                                        require('@/assets/img/icons/power-standby.svg') + '#layer'
                                    "
                                ></use>
                            </svg>
                            <span class="text" v-text="$t('logout')" />
                        </a>
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import LgpdSobreService from '@/services/LgpdSobreService';
import MenuConfig from '@/functions/Menu.js';
import LateralNotification from '@/components/Notification.vue';
import { mapState } from 'vuex';

export default {
    name: 'Header',

    components: {
        LateralNotification,
    },
    data() {
        return {
            logo: require('@/assets/img/logo_sovis_bg.png'),
            isLgpdModalActive: false,
            sobre: {},
            bigScreen: false,
            admin: this.$store.state.user.admin,
            userMenu: [],
            usuarioLogado: this.$store.state.user.nome,
            showNotification: false,
            serviceLgpd: new LgpdSobreService(this.$http),
            menuItemsService: new MenuConfig(),
            notificacaoQtd: 0,
        };
    },
    computed: {
        ...mapState(['hide', 'accessDenied', 'logoutUser', 'showMenu', 'context']),
    },
    watch: {
        hide: {
            deep: true,
            handler: function () {},
        },
        logoutUser(val) {
            if (val) this.doLogout();
        },
    },
    created() {
        if (this.$store.state.partnerSystemHasLayout.url_logotipo_web != null) {
            this.logo = this.$store.state.partnerSystemHasLayout.url_logotipo_web;
        }

        if(this.context != 'jupiter') {
            this.userMenu = this.menuItemsService.loadHeaderDropMenu(
                this.$store.state.app_modulo.disponivel ? this.$store.state.app_modulo.data : null
            );
        }

        /* 
            @86378 - ajuste realizado para que nao fosse mais visivel
            o submenu de integracao - a integracao precisa estar
            como admin no banco, entao foi necessairo remove-la da validacao 
            a partir do Array 'userMenu'
        */
        this.userMenu.admin.splice(1, 1);
        this.notificacaoCount();
        if (process.env.NODE_ENV === 'development') {
            this.notificacaoCount();
        } else {
            this.notificacaoCountInterval();
        }
    },
    methods: {
        confirmLogoutModal() {
            this.$root.confirm({
                message: this.$t('msg-certeza-sair'),
                onConfirm: (_) => this.doLogout(true),
            });
        },
        doLogout() {
            this.isSaving = true;
            this.$axios
                .get('user/logout')
                .then((response) => {
                    if (response.data.status == 500) {
                        this.showMassage(response.data.message);
                        return;
                    }
                    this.$store.dispatch('authenticated', { value: false });
                })
                .catch((error) => {
                    console.log('error', error);
                    if (error.data.message) {
                        this.showMassage(error.data.message);
                    }
                })
                .finally((_) => {
                    // this.isSaving = false;
                });
        },
        b64DecodeUnicode(str) {
            return decodeURIComponent(
                atob(str)
                    .split('')
                    .map(function (c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join('')
            );
        },
        loadSobreLgpd() {
            this.serviceLgpd
                .getSobreAtivo()
                .then((r) => {
                    if (r.content) {
                        this.sobre = r.content;
                        this.sobre.conteudo = this.b64DecodeUnicode(r.content.conteudo);
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar aba prazos', e);
                });
        },
        notificacaoCountInterval() {
            setInterval(() => {
                this.notificacaoCount();
            }, 60 * 5000);
        },
        notificacaoCount() {
            this.$axios.get('geral/notificacao/count.json').then((response) => {
                if (response.data.content) {
                    this.notificacaoQtd = +response.data.content;
                }
            });
        },
        openModalSobreLgpd() {
            this.loadSobreLgpd();
            this.isLgpdModalActive = !this.isLgpdModalActive;
        },
        changeLanguage(name) {
            this.$i18n.locale = name;

            let oldMask = this.$moment.localeData()._config.longDateFormat.L;

            if (name == 'pt') {
                this.$moment.locale('pt-BR');
            } else {
                this.$moment.locale(name);
            }
            this.$store.dispatch('language', { language: this.$moment.locale() });
            let event = new Event('change-locale');
            event.newMask = this.$moment.localeData()._config.longDateFormat.L;
            event.oldMask = oldMask;
            event.convert = (val) => {
                return val
                    ? this.$moment(val, oldMask).isValid()
                        ? this.$moment(val, oldMask).format('L')
                        : val
                    : this.$moment().format('L');
            };
            dispatchEvent(event);
        },
    },
};
</script>
<style lang="scss" scoped>
.buefy-header {
    .header {
        flex-shrink: 0;
        height: 50px;
        justify-content: space-between;
        display: flex;
        width: 100%;
        z-index: 150;
        .item-left {
            display: inline-flex;
            align-items: center;
            padding: 5px;
            margin-left: 10px;
            position: initial;
        }

        .item-right {
            display: inline-flex;
            padding: 5px;
            margin-right: 10px;
            position: initial;

            > .svg-icons {
                margin-top: 10px;
            }
        }
        .notificacao {
            position: relative;
            .contagem {
                position: absolute;
                right: 0;
                top: 0;
                background-color: $green-alert;
                border-radius: 50%;
                line-height: 1;
                min-width: 18px;
                height: 18px;
                margin-top: -6px;
                margin-right: -6px;
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                    color: #fff;
                    font-weight: bold;
                    font-size: 10px;
                    padding: 5px;
                }
            }
        }

        /* Adiciona o espaço automático no primeiro .item-right que aparecer no header */
        :not(.item-right) + .item-right {
            margin-left: auto;
        }

        .lgpd-content {
            .lgpd {
                span {
                    color: #818181;
                }
            }
        }

        .lang {
            display: flex;
            align-items: center;

            .button {
                border: 0;
                background-color: transparent;
                color: $darker-gray-color;

                img {
                    margin-right: 10px;
                }

                &:hover,
                &:focus {
                    color: $darker-gray-color;
                }

                &:focus:not(:active) {
                    box-shadow: none;
                }
            }

            a.dropdown-item {
                display: flex;
                align-items: center;
                color: $darker-gray-color;

                img {
                    margin-right: 10px;
                }

                &:hover {
                    color: $darker-gray-color;
                }
            }
        }

        .dropdown-item {
            cursor: pointer;

            &:active {
                color: $sovis-white !important;
            }
        }

        .user {
            display: flex;
            align-items: center;
            z-index: 151;

            .user-icon {
                display: flex;
                align-items: center;
                height: 38px;
                background-color: $primary-color;
                font-size: 31px;
                border-radius: 40px;
                padding: 0 4px;
                cursor: pointer;

                .svg-icons {
                    height: 25px;
                    width: 30px;
                    fill: $sovis-white;
                }
            }

            .profile-item {
                display: flex;
                color: $darker-gray-color;

                .svg-icons,
                .menu-wrapper {
                    margin-right: 10px;
                }

                .menu-wrapper {
                    width: 20px;
                    height: 20px;
                }

                .menu-icon:before {
                    font-size: 20px;
                }
            }
        }

        .user-item {
            > .text {
                margin-left: 15px;
            }
        }

        .menu-button,
        .notifications {
            font-size: 22px;
            vertical-align: -webkit-baseline-middle;
        }

        .logo {
            height: 30px;
        }

        .mobile-shortcut {
            display: none;
        }

        .sbcomp {
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 9;
            background: rgba(0, 0, 0, 0.5);
        }

        .logo-mobile {
            display: none;
        }
        .usuario-logado {
            opacity: 1 !important;
            border-bottom: 1px solid gainsboro;
            cursor: default !important;
            color: #818181 !important;

            & > span > span {
                margin-right: 10px;
            }
        }

        .usuario-logado:active {
            color: #818181 !important;
        }
    }
}
@media only screen and (max-width: 760px) {
    $logo-size: 161px;
    .buefy-header {
        .header {
            .sidebar {
                border-top: unset;
                left: 0;
                height: 100%;
                position: fixed;
                width: 238px;
                z-index: 10;
                top: 0;
                border-radius: 0;

                > .logo-mobile {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    max-height: 80px;
                    background-color: $sovis-white;
                    margin-top: 50px;

                    > img {
                        max-height: 60px;
                        width: auto;
                    }
                }
            }

            .mobile-shortcut {
                display: flex;
                justify-content: space-around;
                position: fixed;
                background-color: $bg-color;
                width: 100%;
                height: 60px;
                bottom: 0;
                box-shadow: 0px -3px 14px rgba(0, 0, 0, 0.1);
                border-top-left-radius: 15px;
                border-top-right-radius: 15px;
                z-index: 0;

                > .m-shortcut {
                    text-align: center;
                    padding-top: 10px;
                    font-size: 11px;
                    font-weight: 600;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: center;
                    > svg {
                        width: 25px;
                        height: 25px;
                        display: block;
                        margin-bottom: 3px;
                    }
                }
            }

            .active {
                color: $primary-color-click;

                svg {
                    fill: $primary-color-click;
                }
            }

            .item-logo {
                display: none;
            }

            .h-s {
                display: none;
            }
        }
    }
}
</style>
